export default __webpack_public_path__ + "static/desktop_landing-bf-48ce2c69a6b0216f381d36e2a12a33d6.png";